import React from 'react';
import { useSelector } from 'react-redux';

import { makeSelectWallets } from '@/model/wallets/selectors';

import { PreparePageView } from './components';

const selectWallets = makeSelectWallets();

export const PreparePage: React.FC = () => {
  const { selected } = useSelector(selectWallets);
  return <PreparePageView data-test="prepare" readonly={{ wallet: !!selected }} />;
};

export default PreparePage;
